import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = { selected: 0 };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { selected } = this.props;
    this.setState({ selected });
  }

  handleClick(index) {
    const { disabled } = this.props;

    return disabled
      ? false
      : event => {
          event.preventDefault();
          this.setState({ selected: index });
        };
  }

  renderTitles() {
    function labels(child, index) {
      if (child === undefined) return null;
      if (child.props == null) return null;
      const activeClass = this.state.selected === index ? 'active' : '';
      return (
        <li className={`tabs-label ${activeClass}`} key={index}>
          <a role="button" onClick={this.handleClick(index)}>
            {child.props.label}
          </a>
        </li>
      );
    }
    return (
      <nav className="horizontal-nav with-indicator container-fluid website-nav margin-bottom-2x">
        <div className="row">
          <ul className="tabs-labels nav navbar-nav navbar-left">
            {this.props.children.map(labels.bind(this))}
          </ul>
        </div>
      </nav>
    );
  }

  renderContent() {
    return <div className="tabs-content">{this.props.children[this.state.selected]}</div>;
  }

  render() {
    const { disabled } = this.props;
    const className = `tabs ${disabled ? 'tabs--disabled' : ''}`;
    return (
      <div className={className}>
        {this.renderTitles()}
        {this.renderContent()}
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.number.isRequired,
};

Tabs.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  selected: 0,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/common/ui/tabs/Tabs.jsx